import { CheckCircle, Shield } from 'lucide-react';
import { services } from '../data/mock';

const Services = () => {
  return (
    <section id="services" className="services-section">
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <div className="guarantee-badge">
            <Shield size={28} className="guarantee-icon" />
            <span className="guarantee-text">Satisfaction 100% Garantie</span>
          </div>
        </div>
        
        <div className="section-header">
          <h2 className="section-title">Nos Services</h2>
          <p className="section-subtitle">
            {services.description}
          </p>
        </div>

        <div className="services-content-wrapper">
          <div className="services-grid">
            <div className="services-list-container">
              <ul className="services-list">
                {services.list.map((service, index) => (
                  <li key={`service-${index}-${service.substring(0, 20)}`} className="service-list-item">
                    <CheckCircle size={32} className="service-check-icon" />
                    <span>{service}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="services-image-container">
              <img 
                src="https://customer-assets.emergentagent.com/job_simple-web-pro/artifacts/j5mnnzac_IMG_4033.jpg" 
                alt="Outil professionnel de lavage de vitres en action - Lavage de Vitre Bois-Franc" 
                className="services-image"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
